import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonPopover, ModalController } from '@ionic/angular';
import { Group } from '@shared/models/group';
import { GroupFilters } from '@shared/models/group-filters';

@Component({
  selector: 'app-group-selector-container',
  templateUrl: './group-selector-container.component.html',
  standalone: false,
})
export class GroupSelectorContainerComponent {
  @ViewChild('popover') popover: IonPopover;

  @Input() title: string;
  @Input() groupFilters: GroupFilters = {};
  @Input() showAddCustomer: boolean = false;
  @Input() showRemoveParent: boolean = false;
  @Input() presentation: 'modal' | 'popover' = 'modal';

  @Output() selectedGroup = new EventEmitter<Group | undefined>();

  constructor(private modalController: ModalController) {}

  close(): void {
    if (this.presentation === 'modal') {
      this.modalController.dismiss({});
    }
  }

  presentPopover(event: Event): void {
    this.popover.event = event;
    this.popover.present();
  }

  selectGroup(group: Group): void {
    if (this.presentation === 'modal') {
      this.modalController.dismiss({ group });
    } else {
      this.selectedGroup.emit(group);
      this.popover.dismiss();
    }
  }

  removeSelectedParent(): void {
    if (this.presentation === 'modal') {
      this.modalController.dismiss({ group: undefined });
    } else {
      this.selectedGroup.emit(undefined);
      this.popover.dismiss();
    }
  }
}
